'use client';

import { useEffect, useRef } from 'react';
import styles from './GrabCursorLabel.module.scss';

export default function GrabCursorLabel() {
  const labelRef = useRef<HTMLDivElement>(null);
  const pointerRef = useRef<{ x: number; y: number } | null>(null);

  useEffect(() => {
    const update = (x: number, y: number, target: Element | null) => {
      const label = labelRef.current;
      if (!label) {
        return;
      }

      const overGrabbable = target?.closest?.('[data-grabbable]');
      const overInteractive = target?.closest?.('a, button');

      if (overGrabbable && !overInteractive) {
        label.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        label.style.opacity = '1';
      } else if (label.style.opacity !== '0') {
        label.style.opacity = '0';
      }
    };

    const handlePointerMove = (event: PointerEvent) => {
      if (event.pointerType !== 'mouse') {
        return;
      }

      pointerRef.current = { x: event.clientX, y: event.clientY };
      update(event.clientX, event.clientY, event.target as Element | null);
    };

    // for scroll events
    const handleScroll = () => {
      const pointer = pointerRef.current;
      if (!pointer) {
        return;
      }

      update(pointer.x, pointer.y, document.elementFromPoint(pointer.x, pointer.y));
    };

    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    return () => {
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('scroll', handleScroll, { capture: true });
    };
  }, []);

  return (
    <div ref={labelRef} className={styles.grabCursor} aria-hidden="true">
      <span className={styles.label}>GRAB</span>
    </div>
  );
}
